"use client"
import Image from "next/image";
import {getIconColor} from "@/core/shortcut/utils/shortcut.utils";
import ToolsShortcutContainerComponent from "@/core/widget/shortcut/toolsShortcutContainer.component";
import {Column} from "@/core/general/column.component";
import React from "react";
import {MenuBuilderShortcutModel} from "@/core/model/main.model";
import {useTranslations} from "use-intl";

interface Props{
 item:MenuBuilderShortcutModel
}
export default function ShortcutItemComponent(props:Props){
    const t = useTranslations()
    return(
        <Column className={`w-1/4 sm:w-auto px-3 py-2 center relative cursor-pointer ${(props.item.is_enabled??true)?"":"opacity-50"}`}>
            {props.item.icon_url?.includes("http")?
                <Image fill={true} style={{ backgroundColor: getIconColor(props.item.icon_color) }}
                       src={props.item.icon_url}
                       className={"!relative w-full sm:!w-20 !aspect-square w-full !rounded-xl object-contain"}
                       alt={""}/>
                :
                <Image fill={true} style={{ backgroundColor: getIconColor(props.item.icon_color) }}
                       src={`/image/png_ic_${props.item.unique_name}.png`}
                       className={"!relative w-full sm:!w-20 !aspect-square w-full !rounded-xl object-contain"}
                       alt={""}/>
            }
            <div className={"text-sm h-6 mt-2 text-center w-full sm:!w-20 truncate mText"}>{props.item.title?.fa??t(`shName.${props.item.unique_name}`)}</div>
            <ToolsShortcutContainerComponent shortcut={props.item}/>
        </Column>
    )
}